import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="grain-bg min-h-screen bg-zinc-950 text-white p-6 md:p-12" data-testid="payment-cancel-page">
      <div className="max-w-xl mx-auto pt-24 text-center">
        <XCircle className="w-10 h-10 text-zinc-500 mx-auto mb-6" />
        <h1 className="font-heading text-3xl md:text-4xl font-black tracking-tighter mb-3">
          Checkout cancelled.
        </h1>
        <p className="text-sm text-zinc-400 mb-8">
          Your existing balance is unchanged. If your bank shows a debit, check payment confirmation before starting another purchase.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link to="/pricing" className="h-11 px-6 border border-zinc-800 hover:bg-zinc-800 inline-flex items-center rounded-none text-sm">Back to pricing</Link>
          <Link to="/dashboard" className="h-11 px-6 bg-white text-zinc-950 hover:bg-zinc-200 inline-flex items-center rounded-none text-sm font-semibold">Dashboard</Link>
        </div>
      </div>
    </div>
  );
}
